import { createStore } from './createStore.js';

/**
 * Caught-tracking for purely-cosmetic form sets (Unown's letters, Vivillon's
 * patterns, Alcremie's decorations…). Keyed by form slug rather than
 * national dex id, since these are separate `pdx.selection`-style
 * collectibles that all share one species entry.
 */
export const formTracking = createStore('pdx.formTracking', { caught: {} });

export function isFormCaught(slug) {
  return !!formTracking.get().caught[slug];
}

export function toggleFormCaught(slug) {
  formTracking.set((s) => ({
    ...s,
    caught: { ...s.caught, [slug]: !s.caught[slug] },
  }));
}

/** Mark a batch of form slugs caught (e.g. Unown letters from a save import). Never un-marks. */
export function markFormsCaught(slugs) {
  if (!slugs || !slugs.length) return;
  formTracking.set((s) => {
    const caught = { ...s.caught };
    for (const slug of slugs) caught[slug] = true;
    return { ...s, caught };
  });
}
